import React from "react";
import "../../styles/components/facultyProfile/termDetailsSection.scss";
import { Button, Descriptions, Typography, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";

const buildItems = (fields, data) => {
  if (!fields) return [];

  return fields
    .map((field) => {
      if (!data && field.showIf) {
        return null;
      }

      if (data && field.showIf) {
        const { field: depField, value: depValue } = field.showIf;
        const actualValue = data?.[depField];
        if (actualValue != depValue) {
          return null;
        }
      }

      const value = data?.[field.name];
      let displayValue = value;

      if (value === null || value === undefined || value === "") {
        displayValue = "—";
      }

      if (field.type === "yes-no-radio") {
        if (value === 1) displayValue = "Yes";
        else if (value === 0) displayValue = "No";
        else displayValue = "—";
      }

      return {
        key: field.name,
        label: field.label,
        children: displayValue,
      };
    })
    .filter(Boolean);
};

export default function TermDetailsSection({
  title,
  fields,
  data,
  selectedTerm,
  onEdit,
}) {
  return (
    <div className="term-details-section">
      <div className="header">
        <div className="header-row">
          <Typography.Title
            level={3}
            style={{
              margin: 0,
              color: "#8b1438",
              fontFamily: "Palatino",
            }}
          >
            {title}
          </Typography.Title>

          <Button
            size="large"
            style={{ background: "#00573F" }}
            icon={<EditOutlined />}
            type="primary"
            onClick={onEdit}
          >
            Edit
          </Button>
        </div>

        <div>
          <span className="filter-label">Academic Term: </span>
          <Tag>{selectedTerm}</Tag>
        </div>
      </div>

      <Descriptions bordered column={1} items={buildItems(fields, data)} />
    </div>
  );
}
